import React, { Component } from "react";
import {
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  // Input,
  Label,
} from "reactstrap";
import { Formik, Field, Form } from "formik";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";

// import Select from "react-select";
// import CustomSelectInput from "../../../../../../components/common/CustomSelectInput";
import IntlMessages from "../../../../../../helpers/IntlMessages";

import { Blog } from "../../../../../../api/Api";
import { APIClient } from "../../../../../../api/_api";

export default class EditConstant extends Component {
  state = {
    editorState: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        // convertFromHTML(this.props.product.content)
        convertFromHTML(this.props.product.translates.find(x => x.langCode === 'fa').content)
      )
    ),
    langs: [],
    loading: false,
    picture: "",
    file: "",
    imagePreviewUrl: "",
    initialValues: {
      ...this.props.product.translates.find(x => x.langCode === 'fa'),
      picture: "",
    },
  };

  handleChangeLang = async (event) => {
    const initialValues = this.props.product.translates.find(x => x.langCode === event.target.value)

    if (initialValues) {
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(initialValues.content)
        )
      )
      this.setState({
        editorState,
        initialValues
      });
    }
    else {
      const initialValues = {langCode: event.target.value, title: '', content: '', description: ''}
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML('')
        )
      )

      this.setState({
        editorState,
        initialValues
      });
    }
  }

  handleChange = async ({ target }) => {
    try {
      let file = target.files[0],
        src = target.value;

      this.setState({ file, src });
    } catch (error) {}
  };

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    try {
      let newValues = {
        ...values,
        content: draftToHtml(
          convertToRaw(this.state.editorState.getCurrentContent())
        ),
        // cover: this.state.file,
      };
      // console.log(newValues);
      APIClient.defaults.headers["lang"] = values.langCode
      await Blog.editBlog(newValues, this.props.product.id);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML('')
        )
      )

      this.setState({
        editorState,
      });
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };
  handleChange = async ({ target }) => {
    try {
      let file = target.files[0],
        src = target.value;
      var reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          file,
          imagePreviewUrl: reader.result,
        });
      };
      reader.readAsDataURL(file);

      this.setState({ file, src });
    } catch (error) {}
  };
  render() {
    const { editorState } = this.state;
    return (
      <>
        <Modal
          className="blogg"
          onOpened={() => this.handleChangeLang({target: {value: 'fa'}})}
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? <div className="loading" /> : ""}
          <ModalHeader toggle={this.props.toggleModal}>
            <IntlMessages id="pages.edit-new-modal-blog" />
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                  <Label className="mt-4">زبان</Label>
                  <Field
                    name="lang"
                    placeholder="زبان"
                    className="form-control"
                    component="select"
                    onChange={this.handleChangeLang}
                  >
                    {
                      this.props.langs.map((item) => {
                        return (
                          <option value={item.langCode}>{item.name}</option>
                        )
                      })
                    }
                  </Field>

                  <Label className="mt-4">
                    <IntlMessages id="title" />
                  </Label>
                  <Field
                    name="title"
                    placeholder="تیتر  "
                    className="form-control"
                    type="text"
                    required
                  />
                  
                  <Label className="mt-4">
                    <IntlMessages id="description" />
                  </Label>
                  <Field
                    name="description"
                    placeholder="توضیحات  "
                    className="form-control"
                    type="text"
                    required
                  />

                  <Label className="mt-4">
                    <IntlMessages id="توضیحات" />
                  </Label>
                  <div>
                    <Editor
                      editorState={editorState}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      onEditorStateChange={this.onEditorStateChange}
                    />
                    {/* <textarea
                        disabled
                        value={draftToHtml(
                          convertToRaw(editorState.getCurrentContent())
                        )}
                      /> */}
                  </div>
                  {/* <div className="custom-file">
                    <Field
                      name="cover"
                      placeholder="عکس"
                      className="custom-file-input"
                      type="file"
                      onChange={(e) => this.handleChange(e)}
                      accept="image/*"
                    />

                    <label
                      className="custom-file-label"
                      htmlFor="inputGroupFile01"
                    >
                      {this.state.src}
                    </label>
                    {this.state.imagePreviewUrl ? (
                      <img
                        style={{ width: "300px", marginTop: "20px" }}
                        src={this.state.imagePreviewUrl}
                      />
                    ) : (
                      ""
                    )}
                  </div> */}

                  <ModalFooter>
                    <div style={{ marginTop: "100px" }}>
                      <Button
                        color="secondary"
                        outline
                        onClick={this.props.toggleModal}
                      >
                        <IntlMessages id="pages.cancel" />
                      </Button>
                      <Button color="primary" type="submit">
                        <IntlMessages id="pages.submit" />
                      </Button>
                    </div>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
